<template>
    <div class="allTable">
        <Table border :columns="table.column" :data="getListDate()"></Table>
    </div>
</template>
<script>
// import { disUid, bulidUid } from '@/libs/util.js';
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { bulidUid } from '@/libs/util.js'
import { Getter, Mutation } from 'vuex-class'
@Component
export default class PdkTable extends Vue {
    table = {
        data: [],
        column: [
            {
                key: 'uid',
                title: '玩家ID',
                align: 'center',
                width: 70,
                render: (h, params) => {
                    let str = bulidUid(params.row.uid)
                    return h('div', [
                        h('p', str),
                        h(
                            'p',
                            {
                                style: {
                                    color: 'red'
                                }
                            },
                            String(params.row.uid).indexOf(String(params.row.user_id)) > -1 ? '(查询玩家)' : ''
                        )
                    ])
                }
            },
            {
                key: 'base_point',
                title: '底分',
                align: 'center',
                render: (h, params) => {
                    return h('span', this.getMoney(params.row.base_point) || 0)
                }
            },
            {
                key: 'user_bomb',
                title: '炸弹数量',
                align: 'center',
                render: (h, params) => {
                    return h('span', params.row.user_bomb[params.row.uid])
                }
            },
            {
                key: 'bomb_score',
                title: '炸弹金额',
                align: 'center',
                render: (h, params) => {
                    return h('span', this.getMoney(params.row.bomb_score[params.row.uid]))
                }
            },
            {
                key: 'RealAWard',
                title: '输赢金额',
                align: 'center',
                render: (h, params) => {
                    return h('span', this.getMoney(params.row.data.RealAWard))
                }
            },
            {
                key: 'black',
                title: '税收金额',
                align: 'center',
                render: (h, params) => {
                    return h('span', this.getMoney(params.row.data.PercentPoin))
                }
            },
            // {
            //     key: 'black',
            //     title: '游戏身份',
            //     align: 'center',
            //     render: (h, params) => {
            //         return h('span', params.row.land_uid == params.row.uid ? '地主' : '农民');
            //     },
            // },
            {
                key: 'black',
                title: '初始手牌详情',
                align: 'center',
                width: 250,
                render: (h, params) => {
                    let arr = params.row.data.SC || []

                    return h('div', {
                        style: {
                            marginTop: '5px',
                            position: 'relative',
                            height: '50px'
                        },
                        domProps: {
                            innerHTML: arr.map((x, index) => {
                                return "<img style='width:35px;position: absolute;top:0;left:" + index * 12 + 'px;z-index:' + index + ";' src=img/poker/" + x + '.png>'
                            })
                        }
                    })
                }
            },
            {
                key: 'C',
                title: '剩余手牌详情',
                align: 'center',
                width: 250,
                render: (h, params) => {
                    let arr = params.row.data.C || []
                    return h('div', {
                        style: {
                            marginTop: '5px',
                            position: 'relative',
                            height: '50px'
                        },
                        domProps: {
                            innerHTML: arr.map((x, index) => {
                                return "<img style='width:35px;position: absolute;top:0;left:" + index * 12.5 + 'px;z-index:' + index + ";' src=img/poker/" + x + '.png>'
                            })
                        }
                    })
                }
            }
            // {
            //     key: 'land_cards',
            //     title: '底牌详情',
            //     align: 'center',
            //     width: 150,
            //     render: (h, params) => {
            //         let strzo = params.row.land_cards || [];
            //         return h('div', {
            //             style: {
            //                 marginTop: '5PX',
            //             },
            //             domProps: {
            //                 innerHTML: strzo.map((x) => {
            //                     return "<img style='width:35px;' src=img/poker/" + x + '.png>';
            //                 }),
            //             },
            //         });
            //     },
            // },
        ]
    }
    getListDate() {
        let land_uid = JSON.parse(this.listdata[0].opt_detail).land_uid
        let land_cards = JSON.parse(this.listdata[0].opt_detail).land_cards
        let base_point = JSON.parse(this.listdata[0].opt_detail).base_point
        let obj1 = JSON.parse(this.listdata[0].opt_detail).users
        let user_bomb = JSON.parse(this.listdata[0].opt_detail).user_bomb
        let bomb_score = JSON.parse(this.listdata[0].opt_detail).bomb_score
        let arr1 = []
        for (let i in obj1) {
            let Object = {
                user_id: this.listdata[0].user_id,
                land_uid: land_uid,
                uid: i,
                land_cards: land_cards,
                base_point: base_point,
                data: obj1[i],
                user_bomb: user_bomb,
                bomb_score: bomb_score
            }
            arr1.push(Object)
        }
        return arr1
    }
    @Prop()
    listdata
}
</script>
<style lang="less" scoped>
.allTable {
    p {
        color: #333;
        font-size: 16px;
    }
}
</style>
